import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-date-select',
  templateUrl: './date-select.component.html',
  styleUrls: ['./date-select.component.css'],
})
export class DateSelectComponent {
  openDateNotified: any;
  //date: NgbDate = new NgbDate(1789, 7, 14);
  date: NgbDate;
  dateArray: any = [];
  @Output() dateSelected: EventEmitter<any> = new EventEmitter<any>();
  @Input() product: any = [];
  @Input() type: string = '';
  @Input() productId: string = '';
  // @Input() inputDate: string;
  @Input() selectedDate: NgbDate;
  @Input() additionalClasses: string = '';
  cssClasses: string = '';
  @Input() name: string = '';
  @Input() dateString: string = '';

  @Input() inputDate: string = '';

  @Output() resetDateVal: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {
    
    this.splitDate(this.inputDate);
    this.cssClasses = 'date-input' + ' ' + this.additionalClasses;
  }

  onDateSelect(event: NgbDate) {
    
    this.selectedDate = event;
    this.dateSelected.emit({
      event: this.selectedDate,
      productId: this.productId,
      type: this.type,
      dateString: this.formatDate(event),
      date: this.date,
    });
  }

  splitDate(inputDate: string) {
    if (inputDate) {
      this.dateArray = inputDate.split('-');
      this.date = new NgbDate(
        parseInt(this.dateArray[0]),
        parseInt(this.dateArray[1]),
        parseInt(this.dateArray[2])
      );
      this.selectedDate = this.date;
    } else {
    }
  }

  saveDate() {
    this.dateSelected.emit({
      event: this.selectedDate,
      productId: this.productId,
      type: this.type,
    });
  }

  formatDate(event: NgbDate) {
    let selectedDateFormatted =
      this.addZero(event.year) +
      '-' +
      this.addZero(event.month) +
      '-' +
      this.addZero(event.day);
    return selectedDateFormatted;
  }

  addZero(val: number) {
    if (val < 10) return '0' + val;

    return val;
  }

  resetVal() {
    this.resetDateVal.emit({
      event: this.selectedDate,
      productId: this.productId,
      type: this.type,
      dateString: '00-00-00',
      date: this.date,
      action: 'reset',
    });
  }

  clearDate() {
    this.date = new NgbDate(0, 0, 0);
    this.resetVal();
  }
}
